<div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <label class="form-label" for="selectUser">Select User to Impersonate</label>
        <loda-dropdown
            name="selectUser"
            [options]="users"
            [(ngModel)]="userId"
            optionLabel="userName"
            optionValue="userId">
        </loda-dropdown>
    </div>
  </div>
  <div class="modal-footer form-footer">
    <button
      type="button"
      class="btn btn-secondary right"
      (click)="activeModal.dismiss()"
    >
      {{ cancelButtonText }}
    </button>
    <button
      type="button"
      class="btn btn-primary right"
      (click)="activeModal.close(userId)"
      [disabled]="!userId"
    >
      {{ submitButtonText }}
    </button>
  </div>